import {
  USERS_ADDED,
  USER_CONNECTED_TO_SURFER,
  USER_SET_INFORMATIONS,
  USER_SET_LIST_INFORMATION,
  USER_SET_TOKEN,
  USER_SET_LANGUAGE,
  USERS_EDITED,
  USERS_DELETED,
  USER_SET_ROLES,
  USER_ADD_EVENT,
} from 'src/app/redux/redux-types';
import { reduxUserTypes } from 'src/types';
import { UserEditResultType, UsersResultType } from 'src/types/services/user-service.type';

export const setInformation = (informationsPayload: reduxUserTypes.UserLoginInformation) => {
  return {
    type: USER_SET_INFORMATIONS,
    payload: informationsPayload,
  };
};

export const setRoles = (rolesPayload: reduxUserTypes.UserRoleType[]) => {
  return {
    type: USER_SET_ROLES,
    payload: rolesPayload,
  };
};

export const setListInformation = (listInformationsPayload: reduxUserTypes.UserListInformation[]) => {
  return {
    type: USER_SET_LIST_INFORMATION,
    payload: listInformationsPayload,
  };
};

export const setAddInformation = (payload: UsersResultType) => {
  return {
    type: USERS_ADDED,
    payload,
  };
};

export const setUserEdited = (payload: UserEditResultType) => {
  return {
    type: USERS_EDITED,
    payload,
  };
};
export const userDeleted = (payload: string) => {
  return {
    type: USERS_DELETED,
    payload,
  };
};
export const setToken = (tokenPayload: reduxUserTypes.UserTokenInformation) => {
  return {
    type: USER_SET_TOKEN,
    payload: tokenPayload,
  };
};

export const setPreferredLanguage = (payload: reduxUserTypes.SupportedLanguagesKey) => {
  return {
    type: USER_SET_LANGUAGE,
    payload,
  };
};

export const setIsConnectedToSurfer = (payload: boolean) => {
  return {
    type: USER_CONNECTED_TO_SURFER,
    payload,
  };
};

export const addUserEvent = (payload: reduxUserTypes.EventType) => {
  return {
    type: USER_ADD_EVENT,
    payload,
  };
};
